import { render, staticRenderFns } from "./FormPencatatanUtang.vue?vue&type=template&id=772f8f4b"
import script from "./FormPencatatanUtang.vue?vue&type=script&lang=js"
export * from "./FormPencatatanUtang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports